(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
   let announcemnet$bar = new Swiper('.WpSwiperLayoutBar.swiper', { slidesPerView: 'auto', loop: true,autoplay: {delay: 3000} }); 
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["band-future_choice"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.Tab-titl-Link');
    const tabContents = document.querySelectorAll('.Tabs-content-box');
    function switchTab(event) {
      event.preventDefault();
      tabLinks.forEach(link => link.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      const customTabBoxes = document.querySelectorAll('.customTabBox');
      customTabBoxes.forEach(box => box.classList.remove('active'));
      const targetId = event.target.getAttribute('href').substring(1);
      document.querySelector(`#${targetId}`).classList.add('active');
      event.target.classList.add('active');
      const parentTabBox = event.target.closest('li.customTabBox');
      if (parentTabBox) {
        parentTabBox.classList.add('active');
      }
    }
    tabLinks.forEach(link => {
      link.addEventListener('click', switchTab);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["band-lander-image-over-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.Hume-bandbanner-imagpopup').forEach(function(element) {
      element.addEventListener('click', function() {
        document.querySelector('.Hume-popup-overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
        if( window.screen.width > 749 ){
          let popupVd = document.querySelector('.Hume-popup-overlay').querySelector('.video-container.desktop-box').querySelectorAll('video');
          popupVd.forEach((vd)=>{
            if (vd.paused) { vd.play() }
          })
        }else{
          let popupVdMb = document.querySelector('.Hume-popup-overlay').querySelector('.video-container.mobile-box').querySelectorAll('video');
          popupVdMb.forEach((vd)=>{
            if (vd.paused) { vd.play() }
          })          
        }
      });
    });
    document.querySelectorAll('.Hume-popup-close').forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.stopPropagation();
        document.querySelector('.Hume-popup-overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        let popupVdC = document.querySelector('.Hume-popup-overlay').querySelectorAll('video');
        popupVdC.forEach((vd)=>{
          if (!vd.paused) { vd.pause() } 
        })        
      });
    });
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv_giveaway_faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cdvGiveawayFaqItemQuestion').forEach((faqItem)=>{
    faqItem.addEventListener('click', function(evt) {
        evt.preventDefault();
        this.closest('.cdvGiveawayFaqItem').classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom) {
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) { requestAnimationFrame(this.reset.bind(this)); }
    this.currentScrollTop=scrollTop; } hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky' );
    
    this.closeMenuDisclosure(); this.closeSearchModal(); } reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate' );
    this.header.classList.remove('shopify-section-header-hidden'); } reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky' , 'animate' ); }
    closeMenuDisclosure() { this.disclosures=this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure=> disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);

  // document.addEventListener('DOMContentLoaded', ()=>{
    // document.querySelectorAll(`[js-nav-drawer]`).forEach((elm)=>{
    //   elm.addEventListener('click', (target)=>{
    //     target.preventDefault();
    //     target.target.closest('.textlinkone').querySelector('.NavWithElement').classList.add('active');
    //     document.querySelector('.ContainerNavigationUpdated').classList.add('submenu-open');
    //     document.body.classList.add('Menu-drawerVisible');
    //     document.querySelector('#menu-drawer').scroll(0,0);
    //   });
    // })

    // document.querySelectorAll(`.BackNavOpyion`).forEach((elm)=>{
    //   elm.addEventListener('click', (target)=>{
    //     target.preventDefault();
    //     document.querySelectorAll('.NavWithElement').forEach((el)=>{ el.classList.remove('active') });
    //     document.querySelectorAll('.ContainerNavigationUpdated').forEach((el)=>{ el.classList.remove('submenu-open') });
    //     document.body.classList.remove('Menu-drawerVisible');
    //   });
    // }) 

    // document.querySelector('[js-selection-country]').addEventListener('change', (elm)=>{
    //   var value = elm.target.value;
    //   var CounrtyName = elm.target.options[elm.target.selectedIndex].dataset.name;      
    //   document.querySelector('.component-region__select-text').innerHTML = CounrtyName;
    //   let Locform = elm.target.closest('form');
    //   elm.target.closest('form').querySelector('input[name="country_code"]').value = elm.target.options[elm.target.selectedIndex].dataset.value;
    //   if (Locform) Locform.submit();      
    // })    
    
  // })


  // window.addEventListener('scroll', function () {
  //   const ab_header = document.querySelector('.should_be_visible');
  //   if (window.scrollY >= 66) {
  //     ab_header.classList.add('scrolled__vw');
  //   } else {
  //     ab_header.classList.remove('scrolled__vw');
  //   }
  // });
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
 
    document?.querySelectorAll('[js-band-media-popup]')?.forEach(function (element) {
      element?.addEventListener('click', function () {
        document.querySelector('.Hume-popup-overlay').classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (window.screen.width > 749) {
          let popupVd = document
            .querySelector('.Hume-popup-overlay')
            .querySelector('.video-container.desktop-box')
            .querySelectorAll('video');
          popupVd.forEach((vd) => {
            if (vd.paused) {
              vd.play();
            }
          });
        } else {
          let popupVdMb = document
            .querySelector('.Hume-popup-overlay')
            .querySelector('.video-container.mobile-box')
            .querySelectorAll('video');
          popupVdMb.forEach((vd) => {
            if (vd.paused) {
              vd.play();
            }
          });
        }
      });
    });
    document.querySelectorAll('.Hume-popup-close').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.stopPropagation();
        document.querySelector('.Hume-popup-overlay').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        let popupVdC = document.querySelector('.Hume-popup-overlay').querySelectorAll('video');
        popupVdC.forEach((vd) => {
          if (!vd.paused) {
            vd.pause();
          }
        });
      });
    });
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-measurement"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      const container = document.querySelector('.HumeBand-box-outer');
      const blocks = [
          {
              selector: '.Measurement-first-block',
              activeAddOffset: 200,
              activeRemoveOffset: 600,
              containerAddOffset: 300,
              containerRemoveOffset: 900,
              containerClass: 'firstActive'
          },
          {
              selector: '.Measurement-second-block',
              activeAddOffset: 300,
              activeRemoveOffset: 470,
              containerAddOffset: 300,
              containerRemoveOffset: 470,
              containerClass: 'secondActive'
          },
          {
              selector: '.Measurement-third-block',
              activeAddOffset: 500,
              activeRemoveOffset: 900,
              containerAddOffset: 500,
              containerClass: 'thirdActive'
          }
      ];

      function checkScrollPosition() {
          blocks.forEach(block => {
              const element = document.querySelector(block.selector);
              if (!element) return;
              let rect = element.getBoundingClientRect();
              let isActive = rect.top >= 0 - block.activeAddOffset && rect.top <= window.innerHeight - block.activeAddOffset;
              let shouldRemoveActive = rect.top < 0 - block.activeRemoveOffset || rect.top > window.innerHeight;
              let isContainerActive = rect.top >= 0 - block.containerAddOffset && rect.top <= window.innerHeight - block.containerAddOffset;
              let shouldRemoveContainer = rect.top < 0 - block.containerRemoveOffset || rect.top > window.innerHeight;
              if (isActive) {
                  element.classList.add('active');
              } else if (shouldRemoveActive) {
                  element.classList.remove('active');
              }
              if (isContainerActive) {
                  container.classList.add(block.containerClass);
              } else if (shouldRemoveContainer) {
                  container.classList.remove(block.containerClass);
              }
          });
      }
      window.addEventListener('scroll', checkScrollPosition);
      window.addEventListener('resize', checkScrollPosition);
      checkScrollPosition();


    document.querySelectorAll('[js-popup-advertise]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        let targetElementpopup = target.currentTarget.dataset.popup;
        document.querySelector(`.HH-band-tile_expend[data-open-popup="${targetElementpopup}"]`).classList.add('active');
        document.body.classList.add('band-exprend-active');
      })
    })

    document.querySelectorAll('[js-popup-advertise-close]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelectorAll('.HH-band-tile_expend').forEach((elm)=>{elm.classList.remove('active')});
        document.body.classList.remove('band-exprend-active');
      })
    })    

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-testimonial"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const slides = document.querySelectorAll('.testimoniolblock_slider');
        const prevButton = document.querySelector('.prev-swiper-button');
        const nextButton = document.querySelector('.next-swiper-button');
        const currentSlide = document.querySelector('.current-swiper-slide');
        const totalSlides = document.querySelector('.swiper-slides-total');
        let slideOrder = [0, 1, 2];
        const totalSlideCount = slides.length;
        totalSlides.textContent = totalSlideCount;
        function updateSlider() {
            slides.forEach(slide => slide.classList.remove('is-active'));
            slides[slideOrder[1]].classList.add('is-active');
            currentSlide.textContent = slideOrder[1] + 1;
        }
        function nextSlide() {
            slideOrder = [slideOrder[1], slideOrder[2], slideOrder[0]];
            reorderSlides();
        }
        function prevSlide() {
            slideOrder = [slideOrder[2], slideOrder[0], slideOrder[1]];
            reorderSlides();
        }
        function reorderSlides() {
            const parent = slides[0].parentNode;
            slideOrder.forEach(index => parent.appendChild(slides[index]));
            updateSlider();
        }
        nextButton.addEventListener('click', nextSlide);
        prevButton.addEventListener('click', prevSlide);
        updateSlider();
      if (window.innerWidth < 750) {
        var swiper = new Swiper(".HumeBandswiper_container", {
          slidesPerView: 1.1, // Show only 1 full slide and a bit of the next
          spaceBetween: 13,
          loop: true,
          initialSlide: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            init: function () {
              updateSlideNumbers(this);
            },
            slideChange: function () {
              updateSlideNumbers(this);
            },
          },
        });
        function updateSlideNumbers(swiper) {
          document.querySelector(".swiper-current-slide").textContent = swiper.realIndex + 1;
        }
      }
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-summer-body-check-in-ledger"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var windows = [
      { number: '1', label: 'Jul 20 - Aug 2', start: '2026-07-20', end: '2026-08-02' },
      { number: '2', label: 'Aug 3 - Aug 16', start: '2026-08-03', end: '2026-08-16' },
      { number: '3', label: 'Aug 17 - Aug 30', start: '2026-08-17', end: '2026-08-30' },
      { number: '4', label: 'Aug 31 - Sep 13', start: '2026-08-31', end: '2026-09-13' },
      { number: '5', label: 'Sep 14 - Sep 27', start: '2026-09-14', end: '2026-09-27' },
      { number: '6', label: 'Sep 28 - Oct 5', start: '2026-09-28', end: '2026-10-05' }
    ];

    function parseDate(dateString) {
      var parts = dateString.split('-').map(Number);
      return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
    }

    function getCurrentWindow() {
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

      for (var index = 0; index < windows.length; index += 1) {
        var current = windows[index];
        if (today >= parseDate(current.start) && today <= parseDate(current.end)) return current;
      }

      for (var nextIndex = 0; nextIndex < windows.length; nextIndex += 1) {
        if (today < parseDate(windows[nextIndex].start)) return windows[nextIndex];
      }

      return windows[windows.length - 1];
    }

    function applyWindowDefaults() {
      var current = getCurrentWindow();
      var label = document.querySelector('[data-checkin-window-label]');
      var helper = document.querySelector('[data-checkin-window-helper]');
      var numberInput = document.querySelector('[data-checkin-number]');
      var windowInput = document.querySelector('[data-checkin-window]');
      var select = document.querySelector('[data-checkin-window-select]');
      var value = current.number + '|' + current.label;

      if (label) label.textContent = 'Check-in ' + current.number + ': ' + current.label;
      if (helper) helper.textContent = 'Use the same email you used to enter the giveaway.';
      if (numberInput) numberInput.value = current.number;
      if (windowInput) windowInput.value = current.label;
      if (select) select.value = value;
    }

    applyWindowDefaults();
    window.humeCheckInApplyWindowDefaults = applyWindowDefaults;

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-checkin-window-select]')) return;

      var parts = String(event.target.value || '').split('|');
      var numberInput = document.querySelector('[data-checkin-number]');
      var windowInput = document.querySelector('[data-checkin-window]');

      if (numberInput) numberInput.value = parts[0] || '';
      if (windowInput) windowInput.value = parts[1] || '';
    });
  })();

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-hume-checkin-form]');
    if (!form) return;

    event.preventDefault();

    var success = form.querySelector('[data-checkin-success]');
    var error = form.querySelector('[data-checkin-error]');
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    if (formData.get('company')) {
      if (success) success.hidden = false;
      return;
    }

    if (success) success.hidden = true;
    if (error) error.hidden = true;

    var email = String(formData.get('email') || '').trim();
    var firstName = String(formData.get('first_name') || '').trim();
    var lastName = String(formData.get('last_name') || '').trim();
    var checkInNumber = String(formData.get('check_in_number') || '').trim();
    var checkInWindow = String(formData.get('check_in_window') || '').trim();
    var trackingMethod = String(formData.get('tracking_method') || '').trim();
    var currentWeight = String(formData.get('current_weight') || '').trim();
    var scanCount = String(formData.get('scan_count') || '').trim();
    var progressArea = String(formData.get('progress_area') || '').trim();
    var progressStory = String(formData.get('progress_story') || '').trim();
    var proofLink = String(formData.get('proof_link') || '').trim();
    var storyPermission = formData.get('story_permission') === 'yes';

    if (!email || !checkInNumber || !checkInWindow || !trackingMethod || !progressArea || progressStory.length < 20) {
      if (error) {
        error.textContent = 'Please complete the required fields before submitting your update.';
        error.hidden = false;
      }
      return;
    }

    var submittedAt = new Date().toISOString();
    var profileProperties = {
      hume_campaign: 'Summer Body Giveaway 2026',
      hume_signup_source: 'summer_body_giveaway_check_in',
      hume_list_id: 'SPTTq5',
      hume_12_week_challenge: true,
      hume_giveaway_check_in: true,
      hume_latest_check_in_number: checkInNumber,
      hume_latest_check_in_window: checkInWindow,
      hume_latest_check_in_submitted_at: submittedAt,
      hume_latest_tracking_method: trackingMethod,
      hume_latest_current_weight: currentWeight,
      hume_latest_scan_count: scanCount,
      hume_latest_progress_area: progressArea,
      hume_latest_progress_story: progressStory,
      hume_latest_proof_link: proofLink,
      hume_story_permission: storyPermission,
      hume_bonus_entries_earned_this_check_in: 1,
      hume_tags: 'summer-body-giveaway,check-in,bi-weekly-progress,12-week-transformation'
    };

    var ledgerEndpoint = String(form.dataset.ledgerEndpoint || '').trim();
    var payload = {
      source: 'summer_body_giveaway_check_in',
      campaign: 'Summer Body Giveaway 2026',
      email: email,
      first_name: firstName,
      last_name: lastName,
      check_in_number: checkInNumber,
      check_in_window: checkInWindow,
      tracking_method: trackingMethod,
      current_weight: currentWeight,
      scan_count: scanCount,
      progress_area: progressArea,
      progress_story: progressStory,
      proof_link: proofLink,
      story_permission: storyPermission,
      company: String(formData.get('company') || '')
    };

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Submitting...';
    }

    if (!ledgerEndpoint) {
      if (error) {
        error.textContent = 'Check-in submissions are not open yet. Please try again shortly.';
        error.hidden = false;
      }

      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'Submit progress update';
      }

      return;
    }

    fetch(ledgerEndpoint, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok) throw new Error(result.message || 'Ledger submission failed');
          return result;
        });
      })
      .then(function (result) {
        if (window.klaviyo) {
          window.klaviyo.identify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            hume_campaign: profileProperties.hume_campaign,
            hume_latest_check_in_number: checkInNumber,
            hume_latest_check_in_window: checkInWindow
          });
          window.klaviyo.track(
            'Summer Body Giveaway Check-In',
            Object.assign({}, profileProperties, {
              hume_ledger_submission_id: result.submission_id || '',
              hume_entries_awarded: result.entries_awarded || 0,
              hume_duplicate_check_in: Boolean(result.duplicate)
            })
          );
        }

        form.reset();
        if (success) {
          success.textContent = result.duplicate
            ? 'Update received. You already earned the entry for this check-in window, so this duplicate was logged but not counted again.'
            : 'Update submitted. We logged this check-in and added this bonus entry to the giveaway ledger.';
          success.hidden = false;
          success.focus();
        }

        if (window.humeCheckInApplyWindowDefaults) window.humeCheckInApplyWindowDefaults();
      })
      .catch(function (requestError) {
        if (error) {
          error.textContent = requestError.message || 'Something went wrong while saving your check-in. Please try again.';
          error.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Submit progress update';
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-summer-body-check-in"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var windows = [
      { number: '1', label: 'Jul 20 - Aug 2', start: '2026-07-20', end: '2026-08-02' },
      { number: '2', label: 'Aug 3 - Aug 16', start: '2026-08-03', end: '2026-08-16' },
      { number: '3', label: 'Aug 17 - Aug 30', start: '2026-08-17', end: '2026-08-30' },
      { number: '4', label: 'Aug 31 - Sep 13', start: '2026-08-31', end: '2026-09-13' },
      { number: '5', label: 'Sep 14 - Sep 27', start: '2026-09-14', end: '2026-09-27' },
      { number: '6', label: 'Sep 28 - Oct 5', start: '2026-09-28', end: '2026-10-05' }
    ];

    function parseDate(dateString) {
      var parts = dateString.split('-').map(Number);
      return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
    }

    function getCurrentWindow() {
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

      for (var index = 0; index < windows.length; index += 1) {
        var current = windows[index];
        if (today >= parseDate(current.start) && today <= parseDate(current.end)) return current;
      }

      for (var nextIndex = 0; nextIndex < windows.length; nextIndex += 1) {
        if (today < parseDate(windows[nextIndex].start)) return windows[nextIndex];
      }

      return windows[windows.length - 1];
    }

    function applyWindowDefaults() {
      var current = getCurrentWindow();
      var label = document.querySelector('[data-checkin-window-label]');
      var helper = document.querySelector('[data-checkin-window-helper]');
      var numberInput = document.querySelector('[data-checkin-number]');
      var windowInput = document.querySelector('[data-checkin-window]');
      var select = document.querySelector('[data-checkin-window-select]');
      var value = current.number + '|' + current.label;

      if (label) label.textContent = 'Check-in ' + current.number + ': ' + current.label;
      if (helper) helper.textContent = 'Use the same email you used to enter the giveaway.';
      if (numberInput) numberInput.value = current.number;
      if (windowInput) windowInput.value = current.label;
      if (select) select.value = value;
    }

    applyWindowDefaults();
    window.humeCheckInApplyWindowDefaults = applyWindowDefaults;

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-checkin-window-select]')) return;

      var parts = String(event.target.value || '').split('|');
      var numberInput = document.querySelector('[data-checkin-number]');
      var windowInput = document.querySelector('[data-checkin-window]');

      if (numberInput) numberInput.value = parts[0] || '';
      if (windowInput) windowInput.value = parts[1] || '';
    });
  })();

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-hume-checkin-form]');
    if (!form) return;

    event.preventDefault();

    var success = form.querySelector('[data-checkin-success]');
    var error = form.querySelector('[data-checkin-error]');
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    if (formData.get('company')) {
      if (success) success.hidden = false;
      return;
    }

    if (success) success.hidden = true;
    if (error) error.hidden = true;

    var email = String(formData.get('email') || '').trim();
    var firstName = String(formData.get('first_name') || '').trim();
    var lastName = String(formData.get('last_name') || '').trim();
    var checkInNumber = String(formData.get('check_in_number') || '').trim();
    var checkInWindow = String(formData.get('check_in_window') || '').trim();
    var trackingMethod = String(formData.get('tracking_method') || '').trim();
    var currentWeight = String(formData.get('current_weight') || '').trim();
    var scanCount = String(formData.get('scan_count') || '').trim();
    var progressArea = String(formData.get('progress_area') || '').trim();
    var progressStory = String(formData.get('progress_story') || '').trim();
    var proofLink = String(formData.get('proof_link') || '').trim();
    var storyPermission = formData.get('story_permission') === 'yes';

    if (!email || !checkInNumber || !checkInWindow || !trackingMethod || !progressArea || progressStory.length < 20) {
      if (error) {
        error.textContent = 'Please complete the required fields before submitting your update.';
        error.hidden = false;
      }
      return;
    }

    var submittedAt = new Date().toISOString();
    var profileProperties = {
      hume_campaign: 'Summer Body Giveaway 2026',
      hume_signup_source: 'summer_body_giveaway_check_in',
      hume_list_id: 'SPTTq5',
      hume_12_week_challenge: true,
      hume_giveaway_check_in: true,
      hume_latest_check_in_number: checkInNumber,
      hume_latest_check_in_window: checkInWindow,
      hume_latest_check_in_submitted_at: submittedAt,
      hume_latest_tracking_method: trackingMethod,
      hume_latest_current_weight: currentWeight,
      hume_latest_scan_count: scanCount,
      hume_latest_progress_area: progressArea,
      hume_latest_progress_story: progressStory,
      hume_latest_proof_link: proofLink,
      hume_story_permission: storyPermission,
      hume_bonus_entries_earned_this_check_in: 1,
      hume_tags: 'summer-body-giveaway,check-in,bi-weekly-progress,12-week-transformation'
    };

    var ledgerEndpoint = String(form.dataset.ledgerEndpoint || '').trim();
    var payload = {
      source: 'summer_body_giveaway_check_in',
      campaign: 'Summer Body Giveaway 2026',
      email: email,
      first_name: firstName,
      last_name: lastName,
      check_in_number: checkInNumber,
      check_in_window: checkInWindow,
      tracking_method: trackingMethod,
      current_weight: currentWeight,
      scan_count: scanCount,
      progress_area: progressArea,
      progress_story: progressStory,
      proof_link: proofLink,
      story_permission: storyPermission,
      company: String(formData.get('company') || '')
    };

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Submitting...';
    }

    if (!ledgerEndpoint) {
      if (error) {
        error.textContent = 'Check-in submissions are not open yet. Please try again shortly.';
        error.hidden = false;
      }

      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'Submit progress update';
      }

      return;
    }

    fetch(ledgerEndpoint, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok) throw new Error(result.message || 'Ledger submission failed');
          return result;
        });
      })
      .then(function (result) {
        if (window.klaviyo) {
          window.klaviyo.identify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            hume_campaign: profileProperties.hume_campaign,
            hume_latest_check_in_number: checkInNumber,
            hume_latest_check_in_window: checkInWindow
          });
          window.klaviyo.track(
            'Summer Body Giveaway Check-In',
            Object.assign({}, profileProperties, {
              hume_ledger_submission_id: result.submission_id || '',
              hume_entries_awarded: result.entries_awarded || 0,
              hume_duplicate_check_in: Boolean(result.duplicate)
            })
          );
        }

        form.reset();
        if (success) {
          success.textContent = result.duplicate
            ? 'Update received. You already earned the entry for this check-in window, so this duplicate was logged but not counted again.'
            : 'Update submitted. We logged this check-in and added this bonus entry to the giveaway ledger.';
          success.hidden = false;
          success.focus();
        }

        if (window.humeCheckInApplyWindowDefaults) window.humeCheckInApplyWindowDefaults();
      })
      .catch(function (requestError) {
        if (error) {
          error.textContent = requestError.message || 'Something went wrong while saving your check-in. Please try again.';
          error.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Submit progress update';
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-summer-body-giveaway-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stickyCta = document.querySelector('.hume-giveaway__sticky-cta');
    if (!stickyCta) return;

    function updateStickyCta() {
      var threshold = window.innerHeight * 0.18;
      stickyCta.classList.toggle('is-visible', window.scrollY > threshold);
    }

    updateStickyCta();
    window.addEventListener('scroll', updateStickyCta, { passive: true });
    window.addEventListener('resize', updateStickyCta);
  })();

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-klaviyo-giveaway-form]');
    if (!form) return;

    event.preventDefault();

    var formSection = form.closest('.hume-giveaway__form-section');
    var success = form.querySelector('[data-klaviyo-success]');
    var successPanel = formSection ? formSection.querySelector('[data-klaviyo-success-panel]') : null;
    var error = form.querySelector('[data-klaviyo-error]');
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    function showSuccessPanel() {
      if (success) success.hidden = false;

      if (successPanel) {
        form.hidden = true;
        successPanel.hidden = false;
        successPanel.focus();
        return;
      }

      if (success) success.focus();
    }

    if (formData.get('company')) {
      showSuccessPanel();
      return;
    }

    if (success) success.hidden = true;
    if (successPanel) successPanel.hidden = true;
    if (error) error.hidden = true;

    var email = String(formData.get('email') || '').trim();
    var firstName = String(formData.get('first_name') || '').trim();
    var lastName = String(formData.get('last_name') || '').trim();
    var phone = String(formData.get('phone') || '').trim();
    var customerType = String(formData.get('customer_type') || '').trim();
    var primaryGoal = String(formData.get('primary_goal') || '').trim();

    if (!email || !customerType || !primaryGoal) {
      if (error) {
        error.textContent = 'Please complete the required fields before entering.';
        error.hidden = false;
      }
      return;
    }

    var profileProperties = {
      hume_campaign: 'Summer Body Giveaway 2026',
      hume_signup_source: 'summer_body_giveaway_challenge_lp',
      hume_list_id: 'SPTTq5',
      hume_customer_type: customerType,
      hume_primary_goal: primaryGoal,
      hume_phone_raw: phone,
      hume_giveaway_entry: true,
      hume_iphone_giveaway: true,
      hume_12_week_challenge: true,
      hume_tags: 'summer-body-giveaway,hume-health-os,iphone-giveaway,12-week-transformation'
    };

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Summer Body Giveaway Challenge LP',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                last_name: lastName,
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'SPTTq5'
            }
          }
        }
      }
    };

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Submitting...';
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RNQetN', {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2025-04-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (message) {
            throw new Error(message || 'Klaviyo subscription failed');
          });
        }

        if (window.klaviyo) {
          window.klaviyo.identify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            hume_campaign: profileProperties.hume_campaign,
            hume_primary_goal: primaryGoal,
            hume_customer_type: customerType
          });
          window.klaviyo.track('Summer Body Giveaway Signup', profileProperties);
        }

        form.reset();
        showSuccessPanel();
      })
      .catch(function () {
        if (error) {
          error.textContent = 'Something went wrong. Please check your email and try again.';
          error.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Enter the giveaway';
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-summer-body-giveaway-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stickyCta = document.querySelector('.hume-giveaway__sticky-cta');
    if (!stickyCta) return;

    function updateStickyCta() {
      var threshold = window.innerHeight * 0.18;
      stickyCta.classList.toggle('is-visible', window.scrollY > threshold);
    }

    updateStickyCta();
    window.addEventListener('scroll', updateStickyCta, { passive: true });
    window.addEventListener('resize', updateStickyCta);
  })();

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-klaviyo-giveaway-form]');
    if (!form) return;

    event.preventDefault();

    var formSection = form.closest('.hume-giveaway__form-section');
    var success = form.querySelector('[data-klaviyo-success]');
    var successPanel = formSection ? formSection.querySelector('[data-klaviyo-success-panel]') : null;
    var error = form.querySelector('[data-klaviyo-error]');
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    function showSuccessPanel() {
      if (success) success.hidden = false;

      if (successPanel) {
        form.hidden = true;
        successPanel.hidden = false;
        successPanel.focus();
        return;
      }

      if (success) success.focus();
    }

    if (formData.get('company')) {
      showSuccessPanel();
      return;
    }

    if (success) success.hidden = true;
    if (successPanel) successPanel.hidden = true;
    if (error) error.hidden = true;

    var email = String(formData.get('email') || '').trim();
    var firstName = String(formData.get('first_name') || '').trim();
    var lastName = String(formData.get('last_name') || '').trim();
    var phone = String(formData.get('phone') || '').trim();
    var customerType = String(formData.get('customer_type') || '').trim();
    var primaryGoal = String(formData.get('primary_goal') || '').trim();

    if (!email || !customerType || !primaryGoal) {
      if (error) {
        error.textContent = 'Please complete the required fields before entering.';
        error.hidden = false;
      }
      return;
    }

    var profileProperties = {
      hume_campaign: 'Summer Body Giveaway 2026',
      hume_signup_source: 'summer_body_giveaway_challenge_lp',
      hume_list_id: 'SPTTq5',
      hume_customer_type: customerType,
      hume_primary_goal: primaryGoal,
      hume_phone_raw: phone,
      hume_giveaway_entry: true,
      hume_iphone_giveaway: true,
      hume_12_week_challenge: true,
      hume_tags: 'summer-body-giveaway,hume-health-os,iphone-giveaway,12-week-transformation'
    };

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Summer Body Giveaway Challenge LP',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                last_name: lastName,
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'SPTTq5'
            }
          }
        }
      }
    };

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Submitting...';
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RNQetN', {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2025-04-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (message) {
            throw new Error(message || 'Klaviyo subscription failed');
          });
        }

        if (window.klaviyo) {
          window.klaviyo.identify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            hume_campaign: profileProperties.hume_campaign,
            hume_primary_goal: primaryGoal,
            hume_customer_type: customerType
          });
          window.klaviyo.track('Summer Body Giveaway Signup', profileProperties);
        }

        form.reset();
        showSuccessPanel();
      })
      .catch(function () {
        if (error) {
          error.textContent = 'Something went wrong. Please check your email and try again.';
          error.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Enter the giveaway';
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-summer-body-giveaway"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stickyCta = document.querySelector('.hume-giveaway__sticky-cta');
    if (!stickyCta) return;

    function updateStickyCta() {
      var threshold = window.innerHeight * 0.18;
      stickyCta.classList.toggle('is-visible', window.scrollY > threshold);
    }

    updateStickyCta();
    window.addEventListener('scroll', updateStickyCta, { passive: true });
    window.addEventListener('resize', updateStickyCta);
  })();

  function trackSummerBodyGiveawaySubmit(properties) {
    var eventName = 'SummerBodyGiveawaySubmit';
    var eventProperties = {
      content_name: 'Summer Body Giveaway Challenge',
      content_category: 'lead',
      signup_source: 'summer_body_giveaway_challenge_lp'
    };
    properties = properties || {};
    Object.keys(properties).forEach(function (key) {
      eventProperties[key] = properties[key];
    });

    window.__humeSummerBodyGiveawaySubmit = {
      event: eventName,
      properties: eventProperties,
      firedAt: new Date().toISOString()
    };

    if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
    window.dataLayer.push({
      event: eventName,
      content_name: eventProperties.content_name,
      content_category: eventProperties.content_category,
      signup_source: eventProperties.signup_source,
      primary_goal: eventProperties.primary_goal,
      customer_type: eventProperties.customer_type
    });

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, eventProperties);
    }

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, eventProperties);
      window.fbq('track', 'Lead', eventProperties);
      return;
    }

    var params = new URLSearchParams();
    params.append('id', '3189260324703056');
    params.append('ev', eventName);
    params.append('dl', window.location.href);
    params.append('rl', document.referrer || '');
    params.append('if', 'false');
    params.append('ts', String(Date.now()));

    Object.keys(eventProperties).forEach(function (key) {
      params.append('cd[' + key + ']', String(eventProperties[key]));
    });

    new Image().src = 'https://www.facebook.com/tr/?' + params.toString();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-klaviyo-giveaway-form]');
    if (!form) return;

    event.preventDefault();

    var success = form.querySelector('[data-klaviyo-success]');
    var error = form.querySelector('[data-klaviyo-error]');
    var button = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    if (formData.get('company')) {
      if (success) success.hidden = false;
      return;
    }

    if (success) success.hidden = true;
    if (error) error.hidden = true;

    var email = String(formData.get('email') || '').trim();
    var firstName = String(formData.get('first_name') || '').trim();
    var lastName = String(formData.get('last_name') || '').trim();
    var phone = String(formData.get('phone') || '').trim();
    var customerType = String(formData.get('customer_type') || '').trim();
    var primaryGoal = String(formData.get('primary_goal') || '').trim();

    if (!email || !customerType || !primaryGoal) {
      if (error) {
        error.textContent = 'Please complete the required fields before entering.';
        error.hidden = false;
      }
      return;
    }

    var profileProperties = {
      hume_campaign: 'Summer Body Giveaway 2026',
      hume_signup_source: 'summer_body_giveaway_challenge_lp',
      hume_list_id: 'SPTTq5',
      hume_customer_type: customerType,
      hume_primary_goal: primaryGoal,
      hume_phone_raw: phone,
      hume_giveaway_entry: true,
      hume_iphone_giveaway: true,
      hume_12_week_challenge: true,
      hume_tags: 'summer-body-giveaway,hume-health-os,iphone-giveaway,12-week-transformation'
    };

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Summer Body Giveaway Challenge LP',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                last_name: lastName,
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'SPTTq5'
            }
          }
        }
      }
    };

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Submitting...';
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RNQetN', {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2025-04-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (message) {
            throw new Error(message || 'Klaviyo subscription failed');
          });
        }

        if (window.klaviyo) {
          window.klaviyo.identify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            hume_campaign: profileProperties.hume_campaign,
            hume_primary_goal: primaryGoal,
            hume_customer_type: customerType
          });
          window.klaviyo.track('Summer Body Giveaway Signup', profileProperties);
        }

        trackSummerBodyGiveawaySubmit({
          primary_goal: primaryGoal,
          customer_type: customerType
        });

        form.reset();
        if (success) {
          success.hidden = false;
          success.focus();
        }
      })
      .catch(function () {
        if (error) {
          error.textContent = 'Something went wrong. Please check your email and try again.';
          error.hidden = false;
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Enter the giveaway';
        }
      });
  });

  } catch(e) { console.error(e); }
})();
})();
